import { ICommonSettings, IGpsTrackingSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigGpsTrackingSettings } from "./app-settings-config-gps-tracker";

export interface IConfigGpsTrackingInputState {
  showGpsTrackingsModal: boolean;
  editingGpsTrackingSettingsId: string;
}

export interface IConfigGpsTrackingInputProps {
  parentData: string;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigGpsTrackingInput extends PureComponent<IConfigGpsTrackingInputProps, IConfigGpsTrackingInputState> {
  formInputName = ["", "gpsTrackingSettingsId"];

  constructor(props: IConfigGpsTrackingInputProps) {
    super(props);
    this.formInputName[0] = props.parentData;
    this.state = {
      showGpsTrackingsModal: false,
      editingGpsTrackingSettingsId: ""
    };
  }

  openGpsTrackingsModal = () => {
    this.setState({
      editingGpsTrackingSettingsId: "",
      showGpsTrackingsModal: true
    });
  };

  closeGpsTrackingsModal = () => {
    this.setState({ showGpsTrackingsModal: false });
  };

  setEditingGpsTrackings = (id: string) => {
    this.setState({
      editingGpsTrackingSettingsId: id,
      showGpsTrackingsModal: true
    });
  };

  render() {
    const options = [
      { id: null, name: "Default" } as unknown as IGpsTrackingSetting,
      ...(this.props.commonSettings.gpsTrackingSettings || [])
    ];
    return (
      <>
        <ConfigGpsTrackingSettings
          formInputName={this.formInputName}
          closeModal={this.closeGpsTrackingsModal}
          showModal={this.state.showGpsTrackingsModal}
          editingGpsTrackingId={this.state.editingGpsTrackingSettingsId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Settings"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey={
            this.props.parentData === "androidConfig" ? "android_gpstracker_settings" : "ios_gpstracker_settings"
          }
          onAddNew={this.openGpsTrackingsModal}
          onEdit={this.setEditingGpsTrackings}
          dropdownTestId={`${
            this.props.parentData === "androidConfig" ? "android_gpstracker_settings" : "ios_gpstracker_settings"
          }Dropdown`}
          addNewTestId={`${
            this.props.parentData === "androidConfig" ? "android_gpstracker_settings" : "ios_gpstracker_settings"
          }AddNewButton`}
          editTestId={`${
            this.props.parentData === "androidConfig" ? "android_gpstracker_settings" : "ios_gpstracker_settings"
          }EditButton`}
        />
      </>
    );
  }
}
